import{FlatObject as t}from"./FlatObject.mjs";class r extends t{constructor(t){super(t)}}export{r as Other};
